// components/PurchasingIndividualScorecard.jsx
import React, { useState } from 'react';
import { Paper, Box, Text, Switch, Group } from '@mantine/core';
import '@fontsource/orbitron/700.css'; // For bold weight
import PurchasingIndividualScorecardTabSet from './PurchasingIndividualScorecardTabSet.jsx';

const PurchasingIndividualScorecard = () => {
  const [onlyPurchasingWarehouses, setOnlyPurchasingWarehouses] = useState(true);
  
  const warehouseFilter = onlyPurchasingWarehouses ? 'IN' : 'OUT';

  return (
    <Paper elevation={3} sx={{ p: 0, maxWidth: '100%', mt: 2 }}>
      <Group justify="space-between" align="center"  >
        <Text
          component="h1"
          style={{
            fontFamily: 'Orbitron, sans-serif',
            color: '#FDB813',
            fontStyle: 'italic',
            fontSize: '1.5rem',
            marginBottom: 0,
            textAlign: 'left'
          }}
        >
          Purchasing Individual Scorecard
        </Text>
        
        <Switch
          label="Only purchasing warehouses"
          checked={onlyPurchasingWarehouses}
          onChange={(event) => setOnlyPurchasingWarehouses(event.currentTarget.checked)}
          size="sm"
        />
      </Group>
      
      <Box sx={{ mt: 0 }}>
        <PurchasingIndividualScorecardTabSet filter={warehouseFilter} />
      </Box>
    </Paper>
  );
};

export default PurchasingIndividualScorecard;